export function useValidation(initialForm, status) {
  const {
    bankAccountName,
    bankAccountNo,
    bankName,
    customerCode,
    financeEmail,
    financeMobileNo,
    financeName,
    legalName,
    name,
    signatoryDesignation,
    signatoryEmail,
    signatoryMobileNo,
    signatoryName,
    storeType,
    tinNo,
    ipay88SubMid,
    vertical
  } = initialForm;
  const pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );

  const ipay88SubMidErrorMessage = () => {
    if (ipay88SubMid === null || ipay88SubMid === "") {
      return null;
    }
    return null;
  };

  const bankAccountNameMessage = () => {
    if (bankAccountName === null || bankAccountName === "") {
      return "This field is required";
    }
    return null;
  };
  const bankAccountNoMessage = () => {
    if (bankAccountNo === null || bankAccountNo === "") {
      return "This field is required";
    }
    return null;
  };
  const bankNameMessage = () => {
    if (bankName === null || bankName === "") {
      return "This field is required";
    }
    return null;
  };
  const financeEmailMessage = () => {
    if (financeEmail === null || financeEmail === "") {
      return "This field is required";
    } else if (!pattern.test(financeEmail)) {
      return "Enter a valid email address.";
    }
    return null;
  };
  const financeMobileNoMessage = () => {
    if (financeMobileNo === null || financeMobileNo === "") {
      return "This field is required";
    } else if (isNaN(financeMobileNo)) {
      return "Please enter number only";
    }
    return null;
  };
  const financeNameMessage = () => {
    if (financeName === null || financeName === "") {
      return "This field is required";
    }
    return null;
  };
  const legalNameMessage = () => {
    if (legalName === null || legalName === "") {
      return "This field is required";
    }
    return null;
  };
  const nameMessage = () => {
    if (name === null || name === "") {
      return "This field is required";
    }
    return null;
  };
  const signatoryDesignationMessage = () => {
    if (signatoryDesignation === null || signatoryDesignation === "") {
      return "This field is required";
    }
    return null;
  };

  const signatoryMobileNoMessage = () => {
    if (signatoryMobileNo === null || signatoryMobileNo === "") {
      return "This field is required";
    } else if (isNaN(signatoryMobileNo)) {
      return "Please enter number only";
    }
    return null;
  };
  const signatoryEmailMessage = () => {
    if (signatoryEmail === null || signatoryEmail === "") {
      return "This field is required";
    } else if (!pattern.test(signatoryEmail)) {
      return "Enter a valid email address.";
    }
    return null;
  };
  const signatoryNameMessage = () => {
    if (signatoryName === null || signatoryName === "") {
      return "This field is required";
    }
    return null;
  };
  const storeTypeMessage = () => {
    if (storeType === null || storeType === "") {
      return "This field is required";
    }
    return null;
  };
  const tinNoMessage = () => {
    if (tinNo === null || tinNo === "") {
      return "This field is required";
    }
    return null;
  };
  const statusErrorMessage = () => {
    if (
      (status === "ACT" && customerCode === null) ||
      (status === "ACT" && customerCode === "")
    ) {
      return "Please complete the internal details / vertical type of the seller";
    }
    return null;
  };
  const verticalMessage = () => {
    if (
      (storeType === "GENERAL_MERCHANDISE" && vertical === null) ||
      (storeType === "GENERAL_MERCHANDISE" && vertical === "") ||
      (storeType === "GENERAL_MERCHANDISE" &&
        vertical === "FOOD_AND_BEVERAGES") ||
      (storeType === "GENERAL_MERCHANDISE" && vertical === "GROCERY")
    ) {
      return "This field is required";
    }

    return null;
  };

  return {
    bankAccountName: bankAccountNameMessage(),
    bankAccountNo: bankAccountNoMessage(),
    bankName: bankNameMessage(),
    financeEmail: financeEmailMessage(),
    financeMobileNo: financeMobileNoMessage(),
    financeName: financeNameMessage(),
    internalDetails: statusErrorMessage(),
    ipay88SubMid: ipay88SubMidErrorMessage(),
    legalName: legalNameMessage(),

    name: nameMessage(),
    signatoryDesignation: signatoryDesignationMessage(),
    signatoryEmail: signatoryEmailMessage(),
    signatoryMobileNo: signatoryMobileNoMessage(),
    signatoryName: signatoryNameMessage(),
    storeType: storeTypeMessage(),
    tinNo: tinNoMessage(),
    vertical: verticalMessage()
  };
}

export const updateStatusValidation = (initialForm, status) => {
  const {
    customerCode,
    storeType,
    isLargeTaxpayer,
    isPayoutEligible,
    vendorCode,
    vertical
  } = initialForm;

  const verticalMessage = () => {
    if (status === "ACT") {
      if (
        (storeType === "GENERAL_MERCHANDISE" && vertical === null) ||
        (storeType === "GENERAL_MERCHANDISE" && vertical === "") ||
        (storeType === "GENERAL_MERCHANDISE" &&
          vertical === "FOOD_AND_BEVERAGES") ||
        (storeType === "GENERAL_MERCHANDISE" && vertical === "GROCERY")
      ) {
        return "This field is required";
      }
    }

    return null;
  };

  const customerCodeMessage = () => {
    if (status === "ACT") {
      if (customerCode === null || customerCode === "") {
        return "This field is required";
      }
    }

    return null;
  };

  const vendorCodeMessage = () => {
    if (status === "ACT") {
      if (vendorCode === null || vendorCode === "") {
        return "This field is required";
      }
    }

    return null;
  };

  const internalDetailsMessage = () => {
    if (status === "ACT") {
      if (!isLargeTaxpayer && !isPayoutEligible) {
        return "This field is required";
      }
    }

    return null;
  };

  return {
    customerCode: customerCodeMessage(),
    internalDetails: internalDetailsMessage(),
    vendorCode: vendorCodeMessage(),
    vertical: verticalMessage()
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
